<template>
  <div>
    <!-- 第一部分：header+banner，灰色背景 -->
    <div class="bg-gray">
      <div class="home-wrapper" :class="brandClass">
        <header class="header fixed-header">
          <div class="container1200">
            <div class="logo-nav">
              <img :src="navLogoSrc" class="logo-src" alt="logo" />
              <!-- <div class="logo-placeholder">LOGO</div>
              <span class="brand-name">{{ brandName }}</span>
              <span class="brand-domain">bmguanjia.com</span> -->

              <nav class="nav-menu">
                <a href="#">主页</a>
                <a href="#scene">功能介绍</a>
                <a href="#steps">使用场景</a>
                <a href="#about">关于我们</a>
              </nav>
              <button class="login-btn" @click="goLogin">
                {{ loginBtnText }}
              </button>
            </div>
          </div>
        </header>
        <section class="banner">
          <div class="container1200 banner-flex banner-custom">
            <div class="banner-left">
              <div class="banner-title-row">
                <span class="banner-title-main">
                  <template v-if="brandName === '接龙加加'">
                    接龙<span class="main-color">加加</span>
                  </template>
                  <template v-else>
                    报名<span class="main-color">管家</span>
                  </template>
                </span>
                <span class="banner-title-sub">小程序</span>
              </div>
              <div class="banner-subtitle">
                接龙、报名、打卡、签到、统计管理小能手！
              </div>
              <div class="banner-desc">
                安全便捷，高效简易，为您快速收集信息<br />整理各类信息，提升工作效率，开启信息管理新篇章
              </div>
              <button class="main-btn" @click="goLogin">免费使用</button>
            </div>
            <div class="banner-right">
              <img :src="bannerPhoneSrc" class="banner-phone" alt="手机主图" />
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- 第二部分：多场景覆盖，白色背景 -->
    <div class="bg-white">
      <section class="scene" id="scene">
        <div class="container1200">
          <div class="scene-title">
            多场景覆盖，快速创建，智能管理，让组织更高效！
          </div>
          <div class="scene-subtitle">
            告别繁琐，轻松上手，开启智能接龙新时代！
          </div>
          <div class="scene-flex scene-flex-center">
            <div class="scene-left">
              <img :src="scenePhoneSrc" class="scene-phone" alt="手机场景图" />
            </div>
            <div class="scene-right">
              <div class="scene-grid-vertical">
                <div class="scene-row">
                  <div
                    class="scene-item-vertical"
                    v-for="item in sceneList.slice(0, 2)"
                    :key="item.title"
                  >
                    <div class="scene-icon">
                      <img
                        :src="item.iconImg"
                        alt="icon"
                        class="scene-icon-img"
                      />
                    </div>
                    <div class="scene-item-title">{{ item.title }}</div>
                    <div class="scene-item-desc">{{ item.desc }}</div>
                  </div>
                </div>
                <div class="scene-row">
                  <div
                    class="scene-item-vertical"
                    v-for="item in sceneList.slice(2, 4)"
                    :key="item.title"
                  >
                    <div class="scene-icon">
                      <img
                        :src="item.iconImg"
                        alt="icon"
                        class="scene-icon-img"
                      />
                    </div>
                    <div class="scene-item-title">{{ item.title }}</div>
                    <div class="scene-item-desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 第三部分：三步流程，灰色背景 -->
    <div class="bg-gray">
      <section class="steps" id="steps">
        <div class="container1200">
          <div class="steps-title">{{ brandName }}，做您传递信息的小助手</div>
          <div class="steps-subtitle">
            全场景传递信息，一分钟快速创建通知，操作简单，效率高！
          </div>
          <div class="step-list step-list-custom">
            <div
              class="step-item step-item-custom"
              v-for="(step, idx) in steps"
              :key="idx"
            >
              <div class="step-title">第{{ idx + 1 }}步</div>
              <div class="step-desc">{{ step.desc }}</div>
              <img
                :src="stepImgs[idx]"
                class="step-phone-img"
                :alt="'手机图' + (idx + 1)"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 第四部分：关于我们，白色背景 -->
    <div class="bg-white">
      <section class="about" id="about">
        <div class="container1200 about-custom">
          <h2>关于我们</h2>
          <img :src="qrcodeSrc" class="qrcode" alt="二维码" />
          <div class="about-desc">微信扫码免费使用</div>
          <div class="about-desc2">
            {{
              brandName
            }}——对接龙市场需求变化、全新设计的一款微信小程序，体积小巧，功能全面，使用方便
          </div>
        </div>
      </section>
    </div>
    <!-- 备案信息 -->
    <div class="beian-footer">
      <div class="beian">
        &copy;Copyright {{ brandName }}. All Right Reserved
        <a :href="beianUrl" rel="noreferrer" target="_blank">{{ beianText }}</a>
        <span v-if="brandName === '接龙加加'">
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=23010302001622"
            rel="noreferrer"
            target="_blank"
            >黑公网安备23010302001622</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../router/index";
import copyrightConfig from "@/utils/config/changeCopyright.js";
export default {
  data() {
    // 判断品牌
    const isJL = copyrightConfig.AppID === "wx1e899bddb256a5ca";
    const token = localStorage.getItem("token");
    return {
      brandName: isJL ? "接龙加加" : "报名管家",
      brandClass: isJL ? "brand-main-jl" : "brand-main-bmgj",
      mainColor: isJL ? "#2D53C5" : "#2578E3",
      loginBtnText: token ? "管理中心" : "登录/注册",
      beianText: isJL ? "黑ICP备13000410号-107" : "黑ICP备19003235号-71",
      beianUrl: "https://beian.miit.gov.cn/",
      // 图片路径
      navLogoSrc: isJL
        ? require("@/assets/images/imageLand/newpc/pc_logo_web.png")
        : require("@/assets/images/imageLand/newpc/gj_logo_web.png"),
      bannerPhoneSrc: isJL
        ? require("@/assets/images/imageLand/newpc/banner_phone_jl.png")
        : require("@/assets/images/imageLand/newpc/banner_phone_gj.png"),
      scenePhoneSrc: require("@/assets/images/imageLand/newpc/scene_phone.png"),
      qrcodeSrc: isJL
        ? require("@/assets/images/imageLand/pc_ewm.png")
        : require("@/assets/images/bmgj/bmewm.jpg"),

      stepImgs: [
        require("@/assets/images/imageLand/newpc/step_phone1.png"),
        require("@/assets/images/imageLand/newpc/step_phone2.png"),
        require("@/assets/images/imageLand/newpc/step_phone3.png"),
      ],
      sceneList: [
        {
          title: "社群活动",
          desc: "聚会组织：快速统计参与人数，方便安排聚会。社群活动：报名、意见征集、增加互动性。节日活动：统计参与情况，方便准备物资。",
          iconImg: require("@/assets/images/imageLand/newpc/sqhd.png"),
        },
        {
          title: "教育场景",
          desc: "学校活动：管理学校活动，方便老师和家长。课程报名：快速统计报名人数，安排课程。学习小组：分配任务，打卡进度，提升效率。",
          iconImg: require("@/assets/images/imageLand/newpc/jycj.png"),
        },
        {
          title: "工作场景",
          desc: "会议管理：签到、反馈、投票，提升会议效率。活动报名：管理商务活动，方便组织统计。项目协作：分配任务，更新进度，提升协作。",
          iconImg: require("@/assets/images/imageLand/newpc/gzcj.png"),
        },
        {
          title: "通知公告",
          desc: "快速发布：即时发布通知，确保信息及时传达。高效统计：精准锁定目标群体，提升沟通效率。管理便捷：集中管理通知，方便查看与回顾。",
          iconImg: require("@/assets/images/imageLand/newpc/tzgg.png"),
        },
      ],
      steps: [
        { desc: "选择需要创建的接龙场景，点击创建接龙" },
        { desc: "选择适合的模版或者自定义接龙内容，添加填表项" },
        { desc: "输入标题填写信息即可创建，保存并预览接龙" },
      ],
    };
  },
  methods: {
    goLogin() {
      const token = localStorage.getItem("token");
      if (token) {
        router.push("/home");
      } else {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.bg-gray {
  background: #f4f5f7;
}
.bg-white {
  background: #fff;
}
.brand-main-jl {
  --main-color: #2d53c5;
  cursor: pointer;
}
.brand-main-bmgj {
  --main-color: #2578e3;
  cursor: pointer;
}
.main-color {
  color: var(--main-color);
  cursor: pointer;
}
.home-wrapper {
  background: transparent;
  padding-top: 60px;
  cursor: pointer;
}
.fixed-header {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.container1200 {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}
.header {
  height: 60px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 0;
  background: #fff;
  z-index: 100;
  cursor: pointer;
}
.logo-nav {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.logo-src {
  height: 25px;
  cursor: pointer;
  margin-left: 65px;
}
.logo-placeholder {
  width: 80px;
  height: 36px;
  background: #e0e0e0;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
}
.brand-name {
  font-size: 20px;
  font-weight: bold;
  margin-left: 8px;
  color: var(--main-color);
}
.brand-domain {
  margin-left: 8px;
  color: #343a40;
  font-size: 16px;
}
.nav-menu {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 40px;
}
.nav-menu a {
  color: #222;
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s;
}
.nav-menu a:hover,
.nav-menu a:active {
  color: var(--main-color);
}
.login-btn {
  background: var(--main-color);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 16px;
  margin-left: auto;
  cursor: pointer;
  transition: background 0.2s;
}
.login-btn:hover {
  background: #1d357a;
}

/* Banner区定制 */
.banner {
  background: transparent;
  padding: 60px 0 40px 0;
}
.banner-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
}
.banner-custom {
  min-height: 320px;
}
.banner-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 66px;
}
.banner-title-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}
.banner-title-main {
  font-size: 35px;
  font-weight: 800;
  color: #222;
  letter-spacing: 1px;
}
.banner-title-main .main-color {
  font-size: 35px;
  font-weight: 800;
  letter-spacing: 1px;
}
.banner-title-sub {
  font-size: 23px;
  color: #222;
  font-weight: 500;
  margin-left: 8px;
}
.banner-subtitle {
  font-size: 25px;
  font-weight: 700;
  color: #222;
  margin-bottom: 12px;
}
.banner-desc {
  font-size: 18px;
  color: #888;
  margin-bottom: 18px;
  line-height: 1.7;
}
.main-btn {
  background: var(--main-color);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-size: 16px;
  font-weight: 600;
  min-width: 110px;
  min-height: 40px;
  box-shadow: 0 2px 8px rgba(45, 83, 197, 0.08);
  transition: background 0.2s;
}
.main-btn:hover {
  background: #1d357a;
}
.banner-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.img-placeholder {
  background: #f0f0f0;
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  font-size: 16px;
  font-weight: bold;
}
.banner-phone {
  width: 300px;
  min-width: 120px;
  min-height: 240px;
  border-radius: 24px;
  margin-right: 65px;
}
.scene {
  background: transparent;
  padding: 60px 0;
}
.scene-title {
  text-align: center;
  font-size: 33px;
  font-weight: 800;
  color: #343a40;
  margin-top: 0;
  margin-bottom: 10px;
  letter-spacing: 1px;
}
.scene-subtitle {
  text-align: center;
  font-size: 20px;
  color: #888;
  margin-bottom: 40px;
}
.scene-flex {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 60px;
}
.scene-flex-center {
  align-items: center;
}
.scene-left {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  padding-left: 66px;
}
.scene-phone {
  width: 300px;
  //height: 381.88px;
  min-width: 120px;
  min-height: 240px;
  margin-right: 0;
  border-radius: 24px;
}
.scene-right {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.scene-grid-vertical {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.scene-row {
  display: flex;
  flex-direction: row;
  gap: 60px;
  justify-content: center;
}
.scene-item-vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 220px;
  max-width: 320px;
  text-align: left;
}
.scene-icon {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-bottom: 2px;
  flex-shrink: 0;
}
.scene-icon-inner {
  font-size: 28px;
}
.scene-item-title {
  font-size: 20px;
  font-weight: 700;
  color: #343a40;
  margin-bottom: 6px;
  margin-top: 6px;
}
.scene-item-desc {
  font-size: 16px;
  color: #8a90a2;
  line-height: 1.7;
}
.scene-icon-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  display: block;
}
@media (max-width: 1200px) {
  .container1200 {
    padding: 0 16px;
  }
  .scene-flex {
    gap: 20px;
  }
  .scene-row {
    gap: 16px;
  }
}
@media (max-width: 900px) {
  .banner-flex{
    display: block;
  }
  .banner-left{
    padding-left: 0;
    align-items: center;
  }
  .banner-right{
    justify-content: center;
  }
  .banner-phone{
    margin-right: 0;
    margin-top: 30px;
  }
  .scene-flex {
    flex-direction: column;
    align-items: center;
  }
  .scene-left,
  .scene-right {
    justify-content: center;
    padding-left: 0;
  }
  .scene-row {
    flex-direction: column;
    gap: 24px;
  }
  .scene-grid-vertical {
    gap: 24px;
  }
  .scene-item-vertical{
    align-items: center;
  }
}
.steps {
  background: transparent;
  padding: 60px 0 0;
  text-align: center;
}
.steps .container1200 {
  padding: 0;
}
.steps h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 32px;
}
.step-list {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 32px;
  padding: 0 65px;
}
.step-item {
  width: 220px;
}
.step-phone {
  width: 190px;
  height: 235.63px;
}
.step-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.step-desc {
  color: #666;
  font-size: 14px;
  width: 268px;
}
.about {
  background: transparent;
  text-align: center;
  padding: 60px 0 30px 0;
}
.about-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.about .container1200 {
  padding: 0;
}
.about h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 24px;
}
.qrcode {
  width: 180px;
  height: 180px;
  min-width: 80px;
  min-height: 80px;
  margin: 24px 0;
  border-radius: 12px;
}
.about-desc {
  color: #343a40;
  font-size: 15px;
}
.about-desc2 {
  color: #666;
  font-size: 14px;
  margin: 12px 0;
}
.beian-footer {
  width: 100%;
  background: #f4f5f7;
  padding: 24px 0 16px 0;
  text-align: center;
}
.beian {
  color: #8a90a2;
  font-size: 12px;
  text-align: center;
  line-height: 1.8;
}
.beian a {
  color: #8a90a2;
  text-decoration: none;
  margin: 0 4px;
}
.beian a:hover {
  text-decoration: underline;
}
.steps-title {
  text-align: center;
  font-size: 33px;
  font-weight: 800;
  color: #343a40;
  margin-top: 0;
  margin-bottom: 10px;
  letter-spacing: 1px;
}
.steps-subtitle {
  text-align: center;
  font-size: 18px;
  color: #888;
  margin-bottom: 40px;
}
.step-list-custom {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
  margin-top: 30px;
}
.step-item-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
}
.step-title {
  font-size: 25px;
  font-weight: 700;
  color: #343a40;
  margin-bottom: 8px;
  text-align: center;
}
.step-desc {
  font-size: 18px;
  color: #888;
  margin-bottom: 10px;
  text-align: center;
  min-height: 40px;
  width: 260px;
}
.step-phone-img {
  width: 238.13px;
  height: 285.63px;
  object-fit: cover;
  margin-bottom: 0;
  margin-top: 0;
}

@media (max-width: 1200px) {
  .container1200 {
    padding: 0 16px;
  }
  .step-list-custom {
    gap: 20px;
  }
}
@media (max-width: 900px) {
  .step-list-custom {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  .step-item-custom {
    width: 100%;
  }
}

/* 全局鼠标悬停小手（包括文字、图片、图标等） */
a:hover,
button:hover,
[role="button"]:hover,
.main-btn:hover,
.login-btn:hover,
.scene-icon:hover,
.img-placeholder:hover,
.qrcode:hover,
.logo-placeholder:hover,
.scene-item-title:hover,
.step-title:hover,
.about-desc:hover,
.about-desc2:hover {
  cursor: pointer;
}
</style>
